import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pendingleaves: [],
  pendingtimesheets: [],
  regularizations: [],
};

const dashBoardReview = createSlice({
  name: "login",
  initialState,
  reducers: {
    setDashBoardReviewData: (state, action) => {
      return action.payload;
    },
  },
});

export const { setDashBoardReviewData } = dashBoardReview.actions;

export default dashBoardReview.reducer;
